import * as utils from '../../../core/utils/utils'

export interface EntryPoint {
  type: 'JDE' | 'AGRO'
  selected: boolean
}

export class JDEEntryPoint implements EntryPoint {
  type: 'JDE' = 'JDE'

  /** Fournisseur */
  supplier: { value: string | number; label: string }

  /** N° palette */
  pallet: { value: string | number; label: string }

  /** Description article */
  articleDescription: { value: string | number; label: string }

  /** Code article court */
  shortArticleCode: { value: string | number; label: string }

  /** Code article */
  articleCode: { value: string | number; label: string }

  /** Ligne de prod */
  productionLine: { value: string | number; label: string }

  /** N° lot interne */
  internalBatchNumber: { value: string | number; label: string }

  /** N° lot fournisseur */
  supplierBatchNumber: { value: string | number; label: string }

  /** BU lot */
  batchBU: { value: string | number; label: string }

  /** Site code */
  site: { value: string | number; label: string }

  /** Date de réception */
  receptionDate: { value: string; label: string }
  get receptionDateAsDate(): Date {
    return utils.strDateTimeToDate(this.receptionDate.value)
  }

  /** Date de production */
  productionDate: { value: string; label: string }
  get productionDateAsDate(): Date {
    return utils.strDateTimeToDate(this.productionDate.value)
  }

  /** Qté reçue */
  receivedQuantity: { value: string | number; label: string }

  /** Qté produite */
  producedQuantity: { value: string | number; label: string }

  /** Unité de mesure (MU) */
  mesureUnit: { value: string | number; label: string }

  selected: boolean

  constructor(entryPoint: Partial<JDEEntryPoint>) {
    this.supplier = entryPoint.supplier || { value: '', label: '' }
    this.pallet = entryPoint.pallet || { value: '', label: '' }
    this.articleDescription = entryPoint.articleDescription || {
      value: '',
      label: ''
    }
    this.shortArticleCode = entryPoint.shortArticleCode || {
      value: '',
      label: ''
    }
    this.articleCode = entryPoint.articleCode || { value: '', label: '' }
    this.productionLine = entryPoint.productionLine || { value: '', label: '' }
    this.internalBatchNumber = entryPoint.internalBatchNumber || {
      value: '',
      label: ''
    }
    this.supplierBatchNumber = entryPoint.supplierBatchNumber || {
      value: '',
      label: ''
    }
    this.batchBU = entryPoint.batchBU || { value: '', label: '' }
    this.site = entryPoint.site || { value: '', label: '' }
    this.receptionDate = entryPoint.receptionDate || { value: '', label: '' }
    this.productionDate = entryPoint.productionDate || { value: '', label: '' }
    this.receivedQuantity = entryPoint.receivedQuantity || {
      value: '',
      label: ''
    }
    this.producedQuantity = entryPoint.producedQuantity || {
      value: '',
      label: ''
    }
    this.mesureUnit = entryPoint.mesureUnit || { value: '', label: '' }
    this.selected = entryPoint.selected || false
  }
}

export class AGROEntryPoint implements EntryPoint {
  type: 'AGRO' = 'AGRO'

  /** ID of the reception */
  id: { value: string | number; label: string }

  /** Crop (parcel) */
  crop: { value: string | number; label: string }

  /** Product label */
  product: { value: string | number; label: string }

  /** Total quantity of the reception (Kg) */
  quantity: { value: string | number; label: string }

  /** Reception date */
  receptionDate: { value: string; label: string }
  get receptionDateAsDate(): Date {
    return utils.strDateTimeToDate(this.receptionDate.value)
  }

  /** Harvest date */
  harvestDate: { value: string; label: string }
  get harvestDateAsDate(): Date {
    return utils.strDateTimeToDate(this.harvestDate.value)
  }

  /** Site */
  site: { value: string | number; label: string }

  /** Producer name */
  producer: { value: string | number; label: string }

  /** Internal batch number (JDE) */
  batch: { value: string | number; label: string }

  /** Trace code (External producer batch number) */
  traceCode: { value: string | number; label: string }

  selected: boolean

  constructor(entryPoint: Partial<AGROEntryPoint>) {
    this.id = entryPoint.id || { value: '', label: '' }
    this.crop = entryPoint.crop || { value: '', label: '' }
    this.product = entryPoint.product || { value: '', label: '' }
    this.quantity = entryPoint.quantity || { value: '', label: '' }
    this.receptionDate = entryPoint.receptionDate || { value: '', label: '' }
    this.harvestDate = entryPoint.harvestDate || { value: '', label: '' }
    this.site = entryPoint.site || { value: '', label: '' }
    this.producer = entryPoint.producer || { value: '', label: '' }
    this.batch = entryPoint.batch || { value: '', label: '' }
    this.traceCode = entryPoint.traceCode || { value: '', label: '' }
    this.selected = entryPoint.selected || false
  }
}
